import { render, staticRenderFns } from "./CommentsBox.vue?vue&type=template&id=e0d1fa66&scoped=true"
import script from "./CommentsBox.vue?vue&type=script&lang=js"
export * from "./CommentsBox.vue?vue&type=script&lang=js"
import style0 from "./CommentsBox.vue?vue&type=style&index=0&id=e0d1fa66&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0d1fa66",
  null
  
)

export default component.exports